import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/rollen-beteiligte/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="DossierPartyRole"
      returnRoute="/auswahlfelder/dossierPartyRole"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const DossierPartyRoleRoute = Route;
